var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 9,
    viewBox: "0 0 10 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.81366 4.99395C10.0621 4.7089 10.0621 4.28132 9.81366 3.99627L6.45963 0.219345C5.87992 -0.445775 4.98965 0.551904 5.59006 1.21702L7.55694 3.44992C7.72257 3.63996 7.66046 3.78248 7.43271 3.78248L0.621118 3.78248C0.269151 3.78248 -2.14567e-07 4.09129 -1.96915e-07 4.49511C-1.79263e-07 4.89893 0.269151 5.20774 0.621118 5.20774L7.41201 5.20774C7.63975 5.20774 7.70186 5.35026 7.53623 5.5403L5.56936 7.7732C4.98965 8.43832 5.85921 9.45975 6.43892 8.77088L9.81366 4.99395Z",
    fill: "#BFBFBF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.31ffea39de7c5805a37a71296c0756f0.svg";
export { ForwardRef as ReactComponent };